export default __webpack_public_path__ + "static/media/028-motion.ca972b63.svg";